import { useCallback, useEffect, useRef } from 'react';

const useHandleClickOutside = (
  handleOnClickOutside: (event?: MouseEvent) => void,
) => {
  const contentRef = useRef<HTMLDivElement>();

  const handleClickedOutside = useCallback(
    (event: MouseEvent) => {
      if (
        contentRef.current &&
        !contentRef.current?.contains(event.target as Node)
      )
        handleOnClickOutside(event);
    },
    [contentRef, handleOnClickOutside],
  );

  useEffect(() => {
    window.addEventListener('click', handleClickedOutside, true);

    return () => {
      window.removeEventListener('click', handleClickedOutside, true);
    };
  }, [handleClickedOutside]);

  return { contentRef };
};

export default useHandleClickOutside;
